// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

$(document).ready(function() {
  grab_job_counts();
});

document.addEventListener("turbo:render", function(e) {
  //grab_job_counts();
  let frame = document.getElementById("app-dashboard-sidebar");
  if( frame.complete ) {
    $('#job-statuses-menu').foundation();
    //grab_job_counts();
  }
})

function grab_job_counts() {
  //console.log('>>>> grabbing job counts');
  $.get({
    url: '/dashboard/job_counts', 
    success: function(data) {
      var keys = Object.keys(data);
      $(keys).each(function(i, d) {
        $('span[data-count="' + d + '"]').html(data[d]);
      })
    }
  })
}

// Expose globally
window.grab_job_counts = grab_job_counts;



